import { Flag, useFeatureFlags } from '@previo/feature-flags'
import { OtaApiPartner } from '@previo/codebooks'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { Routes } from '~/router/routes'

const checkMyConnectionEditFlag = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const ff = useFeatureFlags()
  await ff.waitForInit()

  // The next detail is gated on both the rollout flag and the OTA (Booking.com only for now);
  // keep this rule here in sync with the eligibility check in DataTableActions.
  const otaId = parseInt(to.params.otaId as string)
  const eligible =
    ff.isEnabled(Flag.MYCONNECTION_EDIT).value && otaId === OtaApiPartner.BOOKING_COM.id

  if (eligible) {
    return next()
  }

  return next({
    name: Routes.SETTINGS_CHANNEL_MANAGER_MY_CONNECTIONS_DETAIL,
    params: to.params,
    query: to.query,
  })
}

export default checkMyConnectionEditFlag
